export enum BrmPrivilege {
  None,
  PackageRole,
  Operations
}
